import React, { Component } from "react";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import Banner from "../shared/banners/Banner";
import styles from "../../assets/css/modules/makeAClaim/make-a-claim.css";
import ChooseClaimType from "./ChooseClaimType";
import { connect } from "react-redux";
import ChangeAddressService from "../../services/ChangeAddressService";



import {
  reset,
  updateMakeAClaimProperties, updateIsNewClaimAndRelatedProperties
} from "../../actions/makeAClaim/MakeAClaimActions";
import IsNewClaimForCondition from "./IsNewClaimForCondition";
import {
  AUTHORISE_TREATMENT,
  CLAIM_BACK,
  CHOSEN_CLAIM_TYPE,
  IS_NEW_CLAIM_CONDITION_CONTENT,
  MUSCLES_BONES_JOINTS_CONDITION,
  OTHER_CONDITION,
  NISSAN,
  BANK_OF_AMERICA
} from "./Constants";
import ClaimBackOptions from "./ClaimBackOptions";
import GetStartedButton from "./GetStartedButton";
import { isHBSFeatureEnabled } from "../../features/FeatureChecks";
import QueryForHBS from "./QueryForHBS";
import {
  PrivateGP,
  DentOptCash,
  DentOptCashPlus
} from "../../constants/SMEModules";
import { shouldShowIfAllSMEModulesMatch } from "../../helpers/SMEModules/smeModuleHelper";
import AreYouThePatient from "./AreYouThePatient";
import HbsPopup from "./HbsPopup";
import DoesNotRequireAuthorisation from "./DoesNotRequireAuthorisation";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import { Urls } from "../../constants/UrlConstants";
import Button from "../shared/buttons/Button";

export const mapStateToMakeAClaim = ({
  makeAClaimReducer,
  policyReducer,
  layoutReducer,
  unreadMessagesReducer
}) => {
  const {
    claimType,
    isNewClaim,
    requiresAuthorisation,
    claimBackOption,
    hasPreSelectedProps,
    isThePatient,
    authoriseTreatmentCondition
  } = makeAClaimReducer;
  return {
    claimType,
    isNewClaim,
    requiresAuthorisation,
    claimBackOption,
    authoriseTreatmentCondition,
    hasPreSelectedProps,
    isThePatient,
    isInternational:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsInternational,
      IsFormat2: policyReducer.selectedPolicy.IsFormat2,
    isSaga: policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsSaga,
    isLargeCorporate: policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.IsLargeCorporate,
    groupNumber: policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.GroupNumber,
    layout: layoutReducer.layout,
    shouldDisplayHbsContent:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.ShouldDisplayHbsContent,
    members: policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.Members,
    isSMEModular: policyReducer.selectedPolicy.IsSMEModular,
    shouldOnlyDisplayClaimBackOptions: shouldShowIfAllSMEModulesMatch(
      policyReducer.selectedPolicy,
      [PrivateGP, DentOptCash, DentOptCashPlus]
    ),
    onlyHasOneOption:
      shouldShowIfAllSMEModulesMatch(policyReducer.selectedPolicy, [
        PrivateGP
      ]) ||
      shouldShowIfAllSMEModulesMatch(policyReducer.selectedPolicy, [
        DentOptCash,
        DentOptCashPlus
      ]),
      featureFlagEP : unreadMessagesReducer.featureFlagEP,
      IsInternalView: policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.IsInternalView,
  };
};

export class MakeAClaim extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      toolTipVisible: false,
      bankInfoVisible:false,
      Authurl:Urls.EngagementPortal[EPDomain_ROOT].preauth,
      ClaimBackUrl : Urls.EngagementPortal[EPDomain_ROOT].claimBackPayment,
      selection:true,
      isCrestDowntime:false,
     };
    this.onbuttonClick = this.onbuttonClick.bind(this);
    this.showBankSection = this.showBankSection.bind(this);

  }
  static content = Store.MakeAClaim;

  componentWillUnmount() {
    this.props.reset();
  }
  componentDidMount() {
    
    if(this.props.IsFormat2){
    new ChangeAddressService()
      .GetServiceStatus()
      .catch(() =>{
     
       this.setState({isCrestDowntime:true});  
      });
    }
  }


  handleCallback = (childData) => {
    this.setState({ Authurl: childData });
};

handleClaimCallback = (childData) => {
  this.setState({ ClaimBackUrl: childData });
};

showBankSection=(isVisible) => {
  this.setState({
    bankInfoVisible: isVisible
  });
};




  onbuttonClick(){
    this.setState({selection : true});
    if(this.props.claimType === AUTHORISE_TREATMENT)
    {
      window.open(this.state.Authurl, "_blank", "noopener");
    }
  else if(this.props.claimType === CLAIM_BACK){
    window.open(this.state.ClaimBackUrl, "_blank", "noopener");
  }
  else if(this.props.claimType === null)
  {
    this.setState({selection : false});
  }
  }

  doYouNeedAuthorisationContent = () => {
    if (this.props.claimType === AUTHORISE_TREATMENT && this.props.isThePatient === null && this.props.authoriseTreatmentCondition === null && this.props.isInternational !== true) {
      return <AreYouThePatient />;
    }
    if (this.props.isInternational && this.props.claimType === AUTHORISE_TREATMENT) {
      return <IsNewClaimForCondition />;
    }
    if (this.props.authoriseTreatmentCondition === MUSCLES_BONES_JOINTS_CONDITION && this.props.isThePatient === true) {
      return <HbsPopup />;
    }
    if (this.props.authoriseTreatmentCondition === OTHER_CONDITION && this.props.isNewClaim === false) {
      return <DoesNotRequireAuthorisation />;
    }
    if (this.props.authoriseTreatmentCondition === OTHER_CONDITION && this.props.isNewClaim === true) {
      return <DoesNotRequireAuthorisation />;
    }
    if (this.props.isThePatient === false && this.props.isNewClaim === false) {
      return <DoesNotRequireAuthorisation />;
    }
    if (this.props.isThePatient === false && this.props.isNewClaim === true) {

      return <DoesNotRequireAuthorisation />;
    }
    if (this.props.isThePatient === true && this.props.isNewClaim === true) {
      return <DoesNotRequireAuthorisation />;
    }
    if (this.props.isThePatient === true && this.props.isNewClaim === false) {
      return <DoesNotRequireAuthorisation />;
    }
    if ((this.props.groupNumber === BANK_OF_AMERICA || this.props.groupNumber === NISSAN || this.ageFlag === true) && this.props.isThePatient === true && this.props.isNewClaim === true) {
      return <DoesNotRequireAuthorisation />;
    }
    return;
  };

  isHBS = () => isHBSFeatureEnabled() && this.props.shouldDisplayHbsContent;
  ageFlag = false;


  chooseClaimTypeSubContent = () => {
    if (
      this.props.isSMEModular &&
      (this.props.shouldOnlyDisplayClaimBackOptions ||
        this.props.onlyHasOneOption)
    ) {
      return <ClaimBackOptions />;
    }
    if (this.props.claimType === AUTHORISE_TREATMENT) {
      if (this.props.members.length > 0 && this.props.members != null) {
        for (var i = 0; i < this.props.members.length; i++) {
          if (this.props.members[i].IsLoggedInMember === true) {
            var today = new Date();
            var birthDate = new Date(this.props.members[i].DateOfBirth);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
              age--;
            }
            if (age === 16 || age === 17) {
              this.ageFlag = true;
            }

          }
          else {
            this.ageFlag = false;
          }
        }
      }
      if (this.props.isThePatient === true && this.props.groupNumber !== BANK_OF_AMERICA && this.props.groupNumber !== NISSAN && this.ageFlag === false) {
        return <QueryForHBS />;
      }
      if ((this.props.groupNumber === BANK_OF_AMERICA || this.props.groupNumber === NISSAN || this.ageFlag === true) && (this.props.isThePatient === true || this.props.isThePatient === false)) {
        return <IsNewClaimForCondition />;
      }
      if (this.props.isThePatient === false && (this.props.groupNumber !== BANK_OF_AMERICA || this.props.groupNumber !== NISSAN || this.ageFlag === false)) {
        return <IsNewClaimForCondition />;
      }

    }

    else if (this.props.claimType === CLAIM_BACK) {
      if (this.props.isInternational) {
        return <GetStartedButton />;
      }
      return <ClaimBackOptions />;
    } else {
      return (
        <p id="helpText" className={styles.helpText}>
          {this.props.content.helpText}
        
      
        </p>
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <Banner
          text={
            this.props.onlyHasOneOption
              ? this.props.content.bannerTextNoChoice
              : this.props.content.bannerText
          }
        />
        <div className={styles.makeAClaimContainer + " container"}>
          <div className="row">
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 mb-5">
            <div className={styles.chooseClaimTypeWrapper}>   
                  <ChooseClaimType selection={this.state.selection} isCrestDowntime={this.state.isCrestDowntime}  bankInfoVisible={this.state.bankInfoVisible} 
                showBankSection={this.showBankSection}
                  featureFlagEP={this.props.featureFlagEP}
                  onlyDisplayClaimback={this.props.shouldOnlyDisplayClaimBackOptions || this.props.onlyHasOneOption}/>
                </div>
                <EPQueryParams url={this.state.Authurl} updatedURL={this.handleCallback}/> 
                <EPQueryParams url={this.state.ClaimBackUrl} updatedURL={this.handleClaimCallback}/> 
                {this.props.featureFlagEP === true ?
                <>
                <div className={styles.selectionError}>
                {this.state.selection === false && this.props.claimType === null ? this.props.content.nonSelectionError: ""}
                </div>
                 <div className="mt-5 text-right">
                  <Button
                    label={this.props.content.startClaim}
                    buttonType="primaryOrangeButton"
                    onClick={ this.onbuttonClick }
                    startClaim={true}
                    disabled={this.props.IsInternalView}
                    IsInternalView={this.props.IsInternalView}
                />
                </div>
                  <p id="helpText" className={styles.helpText}>
                  {this.props.content.helpText}
                </p>
                </>
                :
                (<>
              <div name={CHOSEN_CLAIM_TYPE} className={styles.wrapper}>
                {this.chooseClaimTypeSubContent()}
                
                
              </div>
              <div
                name={IS_NEW_CLAIM_CONDITION_CONTENT}
                className={styles.wrapper}
              >

                {this.props.isInternational &&
                  typeof this.props.isNewClaim === "boolean" ? (
                  <GetStartedButton />
                ) : (
                  this.doYouNeedAuthorisationContent()
                )}
              </div>
                </>)}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToMakeAClaim, {
  reset,
  updateMakeAClaimProperties,
  updateIsNewClaimAndRelatedProperties
})(Contentify(MakeAClaim));
